import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-amber text-dark py-3 px-4 text-center" data-id="element-1">
      <p className="font-lato font-bold uppercase tracking-wider text-xs md:text-sm" data-id="element-2">
        ⚡ Special Launch Offer — Price Goes Up in 48 Hours
      </p>
    </div>;
}